/* Manor Hats AOV pack
   Behaviour for: <aov-ship-bar>, <aov-complete-look>, <aov-cart-addons>, <aov-protect>.
   Works with the Dawn/Refresh cart drawer (cart-drawer.renderContents) and cart page (cart-items.renderContents).
   Config comes from window.AOV, set by snippets/aov-config.liquid (or demo/demo.js locally). */
(function () {
  'use strict';

  var cfg = Object.assign(
    {
      threshold: 0, // cents
      moneyFormat: '${{amount}}',
      cartUrl: '/cart',
      addUrl: '/cart/add',
      updateUrl: '/cart/update',
      textProgress: "You're [amount] away from free standard shipping",
      textUnlocked: "You've unlocked free standard shipping",
      ctlButton: 'Add [count] to cart',
      ctlButtonOne: 'Add to cart',
      ctlButtonAdded: 'Added to cart',
      ctlSelectPrompt: 'Select items to add',
      addLabel: 'Add',
      addedLabel: 'Added',
    },
    window.AOV || {}
  );

  /* ---------- money ---------- */
  function money(cents) {
    var value = (Number(cents) || 0) / 100;
    var fmt = cfg.moneyFormat || '${{amount}}';
    function withCommas(num, decimals, thousands, decimalSep) {
      var fixed = num.toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals ? parts[0] + decimalSep + parts[1] : parts[0];
    }
    var out = fmt
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withCommas(value, 0, '.', ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommas(value, 2, '.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withCommas(value, 0, ',', '.'))
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas(value, 2, ',', '.'));
    // Shopify's money_format can contain HTML (eg. <span class=money>). Strip it for text use.
    return out.replace(/<[^>]+>/g, '');
  }

  /* ---------- cart plumbing ---------- */
  function cartTarget() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-items');
  }

  function sectionsFor(target) {
    if (!target || typeof target.getSectionsToRender !== 'function') return null;
    return target
      .getSectionsToRender()
      .map(function (s) {
        return s.section || s.id;
      })
      .filter(Boolean);
  }

  function postCart(url, body) {
    var target = cartTarget();
    var sections = sectionsFor(target);
    if (sections) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok || json.status) {
          var err = new Error(json.description || json.message || 'Cart error');
          err.payload = json;
          throw err;
        }
        if (target && typeof target.renderContents === 'function' && json.sections) {
          // Dawn's own product form strips is-empty before rendering; do the same or the
          // drawer keeps its empty-state layout and hides the header and items.
          if (json.item_count !== undefined) {
            target.classList.toggle('is-empty', json.item_count === 0);
          } else {
            target.classList.remove('is-empty');
          }
          var footer = document.getElementById('main-cart-footer');
          if (footer && json.item_count !== undefined) footer.classList.toggle('is-empty', json.item_count === 0);
          target.renderContents(json);
        }
        return json;
      });
    });
  }

  function addItems(items) {
    return postCart(cfg.addUrl, { items: items });
  }

  function updateVariantQty(variantId, qty) {
    var updates = {};
    updates[String(variantId)] = qty;
    return postCart(cfg.updateUrl, { updates: updates });
  }

  function fetchCart() {
    return fetch(cfg.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  var refreshTimer = null;
  function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetchCart()
        .then(function (cart) {
          document.querySelectorAll('aov-ship-bar').forEach(function (el) {
            el.update(cart.total_price);
          });
          var inCart = {};
          (cart.items || []).forEach(function (it) {
            inCart[String(it.variant_id || it.id)] = it.quantity;
          });
          document.querySelectorAll('aov-cart-addons').forEach(function (el) {
            el.syncWithCart(inCart);
          });
          document.querySelectorAll('aov-protect').forEach(function (el) {
            el.syncWithCart(inCart);
          });
          document.querySelectorAll('aov-complete-look').forEach(function (el) {
            el.syncWithCart(inCart);
          });
          document.dispatchEvent(new CustomEvent('aov:cart', { detail: cart }));
        })
        .catch(function () {});
    }, 60);
  }

  // Refresh after any cart mutation, whoever made it (theme ATC form, quantity buttons, us).
  var nativeFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
    var p = nativeFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function () {
        refresh();
      }).catch(function () {});
    }
    return p;
  };
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
      refresh();
    });
  }

  function setBusy(button, busy) {
    if (!button) return;
    if (busy) {
      button.dataset.aovLabel = button.innerHTML;
      button.innerHTML = '<span class="aov-spinner" aria-hidden="true"></span>';
      button.disabled = true;
    } else {
      if (button.dataset.aovLabel) button.innerHTML = button.dataset.aovLabel;
      button.disabled = false;
    }
  }

  /* ---------- <aov-ship-bar> ---------- */
  class ShipBar extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.threshold, 10) || cfg.threshold;
      if (this.dataset.total !== undefined && this.dataset.total !== '') {
        this.update(parseInt(this.dataset.total, 10));
      } else {
        refresh();
      }
    }
    update(total) {
      total = Number(total) || 0;
      var threshold = this.threshold || 0;
      if (!threshold) return;
      var remaining = Math.max(threshold - total, 0);
      var pct = Math.min(100, Math.round((total / threshold) * 100));
      var fill = this.querySelector('.aov-ship-bar__fill');
      var text = this.querySelector('.aov-ship-bar__text');
      var track = this.querySelector('.aov-ship-bar__track');
      if (fill) fill.style.width = pct + '%';
      if (track) track.setAttribute('aria-valuenow', String(Math.min(total, threshold)));
      var unlocked = remaining <= 0;
      this.classList.toggle('is-unlocked', unlocked);
      if (text) {
        var tpl = unlocked ? this.dataset.textUnlocked || cfg.textUnlocked : this.dataset.textProgress || cfg.textProgress;
        text.innerHTML = escapeHtml(tpl).replace('[amount]', '<strong>' + escapeHtml(money(remaining)) + '</strong>');
      }
    }
  }
  if (!customElements.get('aov-ship-bar')) customElements.define('aov-ship-bar', ShipBar);

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- <aov-complete-look> ---------- */
  class CompleteLook extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.aov-ctl__button');
      this.summary = this.querySelector('.aov-ctl__summary');
      this.error = this.querySelector('.aov-ctl__error');
      this.addEventListener('change', this.onChange.bind(this));
      if (this.button) this.button.addEventListener('click', this.onAdd.bind(this));
      this.sync();
    }
    checks() {
      return Array.prototype.slice.call(this.querySelectorAll('.aov-ctl__check'));
    }
    selected() {
      return this.checks().filter(function (c) {
        return c.checked && !c.disabled;
      });
    }
    onChange(e) {
      var row = e.target.closest ? e.target.closest('.aov-ctl__row') : null;
      if (row) row.classList.toggle('is-selected', e.target.checked);
      this.sync();
    }
    sync() {
      var sel = this.selected();
      var total = sel.reduce(function (sum, c) {
        return sum + (parseInt(c.dataset.price, 10) || 0);
      }, 0);
      if (this.button) {
        this.button.classList.remove('is-added');
        if (sel.length === 0) {
          this.button.disabled = true;
          this.button.textContent = cfg.ctlSelectPrompt;
        } else {
          this.button.disabled = false;
          var label = sel.length === 1 ? cfg.ctlButtonOne : cfg.ctlButton.replace('[count]', sel.length + ' items');
          this.button.textContent = label + ' · ' + money(total);
        }
      }
      if (this.summary) {
        this.summary.textContent = sel.length ? sel.length + (sel.length === 1 ? ' item' : ' items') + ' selected' : '';
      }
    }
    syncWithCart(inCart) {
      // Mark add-ons already in the bag so they are not double-added by accident.
      this.checks().forEach(function (c) {
        var row = c.closest('.aov-ctl__row');
        var already = !!inCart[String(c.value)] && !row.classList.contains('is-this');
        row.classList.toggle('is-in-cart', already);
        var note = row.querySelector('.aov-ctl__kicker');
        if (note && note.dataset.default === undefined) note.dataset.default = note.textContent;
        if (note) note.textContent = already ? 'In your bag' : note.dataset.default;
      });
    }
    onAdd() {
      var self = this;
      var items = this.selected().map(function (c) {
        return { id: parseInt(c.value, 10), quantity: 1 };
      });
      if (!items.length) return;
      // Shopify lists the most recently added line first: add the add-ons first so the hat tops the cart.
      items.reverse();
      if (this.error) this.error.textContent = '';
      setBusy(this.button, true);
      addItems(items)
        .then(function () {
          setBusy(self.button, false);
          self.checks().forEach(function (c) {
            if (!c.closest('.aov-ctl__row').classList.contains('is-this')) {
              c.checked = false;
              c.closest('.aov-ctl__row').classList.remove('is-selected');
            }
          });
          self.sync();
          self.button.textContent = cfg.ctlButtonAdded;
          self.button.classList.add('is-added');
          self.button.disabled = false;
        })
        .catch(function (err) {
          setBusy(self.button, false);
          self.sync();
          if (self.error) self.error.textContent = err.message || 'Could not add to cart';
        });
    }
  }
  if (!customElements.get('aov-complete-look')) customElements.define('aov-complete-look', CompleteLook);

  /* ---------- <aov-cart-addons> ---------- */
  class CartAddons extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }
    onClick(e) {
      var btn = e.target.closest ? e.target.closest('.aov-addons__add') : null;
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var id = parseInt(btn.dataset.variant, 10);
      if (!id) return;
      setBusy(btn, true);
      addItems([{ id: id, quantity: 1 }])
        .then(function () {
          // The drawer re-renders from the server and drops this item, so nothing else to do.
          setBusy(btn, false);
          btn.textContent = cfg.addedLabel;
          btn.disabled = true;
        })
        .catch(function () {
          setBusy(btn, false);
        });
    }
    syncWithCart(inCart) {
      this.querySelectorAll('.aov-addons__item').forEach(function (li) {
        var id = li.dataset.variant;
        var hide = !!inCart[String(id)];
        li.hidden = hide;
      });
      var visible = this.querySelectorAll('.aov-addons__item:not([hidden])').length;
      this.hidden = visible === 0;
    }
  }
  if (!customElements.get('aov-cart-addons')) customElements.define('aov-cart-addons', CartAddons);

  /* ---------- <aov-protect> ---------- */
  class Protect extends HTMLElement {
    connectedCallback() {
      this.check = this.querySelector('.aov-protect__check');
      if (this.check) this.check.addEventListener('change', this.onChange.bind(this));
    }
    onChange() {
      var self = this;
      var id = parseInt(this.check.dataset.variant, 10);
      if (!id) return;
      this.classList.add('is-busy');
      updateVariantQty(id, this.check.checked ? 1 : 0)
        .then(function () {
          self.classList.remove('is-busy');
        })
        .catch(function () {
          self.check.checked = !self.check.checked;
          self.classList.remove('is-busy');
        });
    }
    syncWithCart(inCart) {
      if (!this.check) return;
      this.check.checked = !!inCart[String(this.check.dataset.variant)];
    }
  }
  if (!customElements.get('aov-protect')) customElements.define('aov-protect', Protect);

  window.AOVPack = { money: money, addItems: addItems, refresh: refresh };
})();
